import React, { useState, useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getAssociateSaleSetup } from '../../../../actions/associatesActions';
import { useDispatch } from 'react-redux';
import Header from '../../../../components/Common/Header/Header';
import ContentApp from '../../../../components/ContentApp';
import Button from '../../../../components/Common/Button/Button';
import ScanFaceScreen from '../ScanScreen/ScanFaceScreen';
import { useTranslation } from 'react-i18next';
import FixedButton from '../../../../components/Common/FixedButton/FixedButton';
import ProcessingScreen from '../../../Common/ProcessingScreen';
import { WelletContext } from '../../../../context/WelletContext';

const SelfieValidateKyc = ({ history }) => {
  const kycStatus = useSelector((state) => state.associates.user.kycStatus);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const welletContext = useContext(WelletContext);
  const [selfie, setSelfie] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const jwt = useSelector((state) => state.associates.jwt);

  const handleCaptureFace = (img) => {
    setSelfie(img);
  };

  useEffect(() => {
    if (history.location.state === undefined) {
      history.push('/kyc-start');
    }
  }, []);

  useEffect(() => {
    if (kycStatus === 'APPROVED') {
      history.push('/');
    }
  }, [kycStatus]);

  const handleConfirmFace = async () => {
    setIsLoading(true);
    let response = null;
    try {
      response = await welletContext.apis.tickets.put('users/kyc', {
        document: history.location.state.frontImage,
        documentback: history.location.state.backImage,
        face: selfie,
      });

      if (response.data.success) {
        history.push({
          pathname: '/kyc-validate-finish',
          state: { response: response },
        });
        dispatch(getAssociateSaleSetup(jwt));
      } else {
        history.push({
          pathname: '/kyc-validate-finish',
          state: { response: response },
        });
        dispatch(getAssociateSaleSetup(jwt));
      }
    } catch (error) {
      setIsLoading(false);
      history.push({
        pathname: '/kyc-validate-finish',
        state: { response: { data: { success: false }, errors: ['DATA_ERROR'] } },
      });
    }
  };

  const handleReset = () => {
    setSelfie(null);
  };

  /******** ESTO NO VA *********/
  const onChange = (e) => {
    const files = e.target.files;
    const file = files[0];
    getBase64(file);
  };

  const onLoad = async (fileString) => {
    let response = null;
    response = await welletContext.apis.tickets.put('users/kyc', {
      document: history.location.state.frontImage,
      documentback: history.location.state.backImage,
      face: fileString,
    });

    if (!response.data.success && response.data.errors.some((e) => e === 'REQUEST_USER_DATA')) {
      history.push({
        pathname: '/sign-up-personal-information',
      });
    } else {
      dispatch(getAssociateSaleSetup(jwt));
      history.push({
        pathname: '/kyc-validate-finish',
        state: { response: response },
      });
    }
  };

  const getBase64 = (file) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      onLoad(reader.result);
    };
  };
  /******** ESTO NO VA *********/

  return (
    <>
      {isLoading && isLoading ? (
        <ProcessingScreen title={t('wait')} subtitle={t('verifyingAccount')} />
      ) : (
        <>
          <Header pathName={'/kyc-start'} />
          <ContentApp background={true}>
            <div>
              {selfie ? (
                <div className='container p-0 text-center'>
                  <div className='font-medium bold' style={{ color: 'var(--color-font-primary)' }}>
                    {t('kyc.confirmPicture')}
                  </div>
                  <div className='mt-2 text-secondary'>{t('kyc.selfieConfirm')}</div>

                  <div
                    className='camera-container validate mt-4'
                    style={{ width: '100%', height: '315px', overflow: 'hidden' }}
                  >
                    <div className='mask-face' style={{ transform: 'scaleX(-1)' }}>
                      <img src={selfie} alt='Captured face' />
                      <div className='face'></div>
                    </div>
                  </div>

                  <div className='text-center'>
                    <div
                      onClick={handleReset}
                      className='mt-4'
                      style={{
                        color: 'var(--color-primary)',
                        zIndex: 30,
                        position: 'absolute',
                        right: 0,
                        left: 0,
                        bottom: '-13%',
                      }}
                    >
                      {t('kyc.tryAgain')}
                    </div>
                    <FixedButton>
                      <Button
                        text={t('confirm')}
                        size='large'
                        onClick={handleConfirmFace}
                        fontSize={'17px'}
                        icon={true}
                        typeIcon='arrow'
                        iconColor='#000'
                        className='btn-primary'
                      />
                    </FixedButton>
                  </div>
                </div>
              ) : (
                <>
                  {process.env.REACT_KYC_TESTING ? (
                    <input type='file' onChange={onChange} />
                  ) : (
                    <ScanFaceScreen onCaptureFace={handleCaptureFace} />
                  )}
                </>
              )}
            </div>
          </ContentApp>
        </>
      )}
    </>
  );
};
export default SelfieValidateKyc;
